var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 9.10457 0.895431 10 2 10H6C7.10457 10 8 9.10457 8 8V2C8 0.89543 7.10457 0 6 0H2C0.895431 0 0 0.895431 0 2V8ZM0 16C0 17.1046 0.895431 18 2 18H6C7.10457 18 8 17.1046 8 16V14C8 12.8954 7.10457 12 6 12H2C0.895431 12 0 12.8954 0 14V16ZM10 16C10 17.1046 10.8954 18 12 18H16C17.1046 18 18 17.1046 18 16V10C18 8.89543 17.1046 8 16 8H12C10.8954 8 10 8.89543 10 10V16ZM12 0C10.8954 0 10 0.895431 10 2V4C10 5.10457 10.8954 6 12 6H16C17.1046 6 18 5.10457 18 4V2C18 0.89543 17.1046 0 16 0H12Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.1286fb6f25eb574853cdd105794ce512.svg";
export { ForwardRef as ReactComponent };